export function shouldHideAssignmentControls(task?: {
  is_originator_view?: boolean;
} | null): boolean {
  return task?.is_originator_view === true;
}
